// src/pages/programs/Programs.jsx

import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import ProgramsTable from "../../components/programs/ProgramsTable";

const Programs = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ProgramsTable />
        </WrapperSection>
    );
};

export default Programs;
